import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    width: '100%',
    position: 'relative',
    flexDirection: 'column',
  },
  containerApplication: {
    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.12), 0px 0px 0px 1px rgba(19, 45, 74, 0.04)',
  },
  button: {
    color: theme.palette.secondary.dark,
  },
  bookingClick: {
    width: '50%',
    '&:hover': {
      '& $button': {
        color: theme.palette.primary.main,
      },
      cursor: 'pointer',
    },
  },
  details: {
    width: '50%',
  },
  width: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    '& .navigationTabs': {
      width: '100%',
      '& .MuiTabs-scroller': {
        '& .MuiTabs-flexContainer': {
          '& .MuiButtonBase-root': {
            width: '50%',
            marginRight: 0,
            marginLeft: 0,
          },
        },
      },
    },
  },
  divider: {
    border: `1px solid ${theme.palette.common.white}`,
    borderBottomColor: theme.palette.secondary.light,
    width: '90%',
    margin: 'auto',
  },
  cancel: {
    width: '100%',
    marginTop: 24,
    margin: 'auto',
  },
  updateInformation: {
    padding: '0 16px',
    marginTop: 'calc(24px - 16px)',
  },
}))
